<template>
  <HotMerchantSkeleton :isReady="isReady">
    <div class="module-header">
      <span class="title">{{ $t('热门人气榜单') }}</span>
      <div class="more-btn" @click="onClickMore" v-stat.click="{ tag: 'hot-merchant.view_all' }" >
        {{ $t('更多推荐') }}
        <ArrowRightIcon width="20" color="rgba(0,0,0,0.3)"/>
      </div>
    </div>
    <div class="hot-merchant-list">
      <!-- 商户列表 -->
      <template v-for="(item, index) in showHotMerchantDpList">
        <div
          class="hot-merchant-wrapper"
          :style="{ backgroundImage: `url(${item.logo})` }"
          :key="index"
          v-if="item.merchantList.length > 0"
          v-stat.brow="{ tag: 'hot-merchant.card_brow', ext: { ftitle: item.title } }"
        >
          <div class="hot-merchant-header">
            <span class="header-title">{{ item.title }}</span>
            <div
              class="more-btn"
              v-stat.click="{ tag: 'hot-merchant.more_recommend', ext: { ftitle: item.title } }"
              @click="goToMerchantDetail(item.contentPosition)"
            >
              <span>{{ i18n('更多') }}</span>
            </div>
          </div>
          <div class="item-list">
            <ThemeCard
              class="theme-card"
              v-for="card in item.merchantList.slice(0, index === 0 ? 6 : 3)"
              :key="card.title"
              :cardInfo="card"
              :isShowCardDesc="false"
            ></ThemeCard>
          </div>
        </div>
      </template>
    </div>
  </HotMerchantSkeleton>
</template>

<script lang="ts" setup>
import { ref, onBeforeMount, computed } from 'vue';
import { ArrowRightIcon } from '@tencent/wphk-icon-vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useRouter } from 'vue-router/composables';
import { ModuleName } from '@/types/module-type';
import { MerchantDpList } from '@/types/merchant';
import HotMerchantSkeleton from '@/components/skeleton/travel-tool-skeleton.vue';
import { i18n } from '@/i18n';
import { useConfigStore, useDpStore } from '@/store';

const props = defineProps<{ moduleName: ModuleName }>();
const emit = defineEmits(['onHideModule']);

const router = useRouter();

// store
const { getConfig } = useConfigStore();
const dpStore = useDpStore();

const isReady = ref(false);


// 热门商户卡片
const hotMerchantDpList = ref<MerchantDpList[]>([]);
const showHotMerchantDpList = computed(() => hotMerchantDpList.value.filter(item => item.isHomeShow));
// 进入推荐详情
function goToMerchantDetail(contentPosition: string) {
  router.push({ name: 'merchantDetail', query: { id: contentPosition } });
}
// 点击查看全部
const onClickMore = () => {
  router.push({ name: 'merchantDetail' });
};

onBeforeMount(async () => {
  const { isMerchantInited, merchantDpList } = dpStore;
  if (!isMerchantInited) {
    const { merchantDpList } = await getConfig(props.moduleName);
    hotMerchantDpList.value = merchantDpList;
  } else {
    hotMerchantDpList.value = merchantDpList;
  }

  isReady.value = true;

  // 没有内容隐藏该模块
  if (!hotMerchantDpList.value.length) {
    emit('onHideModule', props.moduleName);
  }
});
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.module-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16/@rem;
  .title {
    .font-34-medium();
    font-size: 38/@rem;
    line-height: 48/@rem;
  }
  .more-btn {
    .font-28-regular(rgba(0,0,0,0.5));
    display: flex;
    align-items: center;
    .icon {
      margin-left: 10/@rem;
    }
  }
}
.hot-merchant-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.hot-merchant-wrapper {
  width: 100%;
  box-sizing: border-box;
  margin-top: 16/@rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  &:first-child {
    margin-top: 0;
  }
  .hot-merchant-header {
    padding: 32/@rem 24/@rem 0 24/@rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-title {
      .font-32-medium();
    }
    .more-btn {
      .font-24-regular();
      padding: 0 16/@rem;
      background: rgba(255, 255, 255, 0.60);
      border-radius: 24/@rem;
      line-height: 40/@rem !important;
      .actived();
    }
  }
  .item-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    /deep/ .theme-card {
      width: 33%;
      box-sizing: border-box;
      padding: 16/@rem 0;
      &-wrapper {
        flex-direction: row;
        .logo {
          min-width: 64/@rem;
          height: 64/@rem;
          margin-right: 16/@rem;
        }
      }
      &:nth-child(3n+1) {
        padding-left: 32/@rem;
      }
    }
  }
  &:not(:first-child) {
    width: calc(50% - 0.04rem);
    /deep/ .theme-card {
      width: 100%;
      padding-left: 32/@rem;
    }
  }
}
</style>
